import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { UserManagementService } from '../../../../services/management/user-management.service';
import { map, Observable, Subscription, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-data-tab',
    templateUrl: './data-tab.component.html',
    styleUrls: ['./data-tab.component.scss']
})
export class DataTabComponent implements OnInit, OnDestroy {
    constructor(
        private rootFormGroup: FormGroupDirective,
        private userManagementService: UserManagementService,
        private translate: TranslateService
    ) {}

    @Input() formGroupName: string = 'userData';
    @Input() editUser: boolean = false;

    form: FormGroup = new FormGroup({});
    rolesOptions$: Observable<string[]> = new Observable<string[]>();

    changePassword$: Subscription = new Subscription();

    ngOnInit() {
        this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;

        this.rolesOptions$ = this.userManagementService.getRoles().pipe(map((roles) => roles.filter((role) => role !== 'guest')));

        if (this.editUser) {
            this.changePassword?.setValue(false);
            this.form.controls['password']?.disable();
            this.changePassword$ = this.changePassword!.valueChanges.pipe(
                tap((value) => {
                    if (value) {
                        this.form.controls['password']?.enable();
                    } else {
                        this.form.controls['password']?.disable();
                    }
                })
            ).subscribe();
        }
    }

    // getter
    get gender() {
        return this.form.get('gender');
    }
    get userName() {
        return this.form.get('userName');
    }
    get firstName() {
        return this.form.get('firstName');
    }
    get lastName() {
        return this.form.get('lastName');
    }
    get email() {
        return this.form.get('email');
    }
    get password() {
        return this.form.get('password');
    }
    get isGuestAccount() {
        return this.form.get('isGuestAccount');
    }

    get changePassword() {
        return this.form.get('changePassword');
    }

    // setter
    set setPassword(password: string) {
        this.password?.setValue(password);
    }

    generatePassword() {
        const possibleChars: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890,./;'[]\\=-)(*&";
        const passwordLength: number = 10;

        this.setPassword = this.generateRandomString(possibleChars, passwordLength);
    }

    translateRole(role: string): string {
        return this.userManagementService.translateRoles(role);
    }

    buildSelectedItemKey(selectedRoles: string[] | undefined): string[] {
        if (selectedRoles && selectedRoles.length > 0) {
            return selectedRoles.map((selectedRole) => ' ' + this.translate.instant(`USERMANAGEMENT.MODAL_USER_ROLES_${selectedRole.toUpperCase()}`));
        } else {
            return [this.translate.instant('USERMANAGEMENT.TABLE_HEADING_ROLES')];
        }
    }

    ngOnDestroy() {
        this.changePassword$.unsubscribe();
    }

    private generateRandomString(possibleChars: string, passwordLength: number): string {
        let password: string = '';

        for (let i = 0; i < passwordLength; ++i) {
            password += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
        }

        return password;
    }
}
